export const sportMeta: Record<
  string,
  { emoji?: string; svgUrl?: string; colorScheme: string; color: string }
> = {
  Cricket: { 
    emoji: "🏏", 
    colorScheme: "sport-color--yellow",
    color: "#facc15" // yellow
  },
  Basketball: { 
    emoji: "🏀", 
    colorScheme: "sport-color--orange",
    color: "#fb923c" // orange
  },
  Soccer: { 
    emoji: "⚽", 
    colorScheme: "sport-color--blue",
    color: "#60a5fa" // blue
  },
  Football: { 
    emoji: "🏈", 
    colorScheme: "sport-color--red",
    color: "#ef4444" // red
  },
  Hockey: { 
    emoji: "🏒", 
    colorScheme: "sport-color--cyan",
    color: "#22d3ee" // cyan
  },
  Baseball: { 
    emoji: "⚾", 
    colorScheme: "sport-color--emerald",
    color: "#10b981" // emerald
  },
  Default: { 
    svgUrl: "/default_logo_sport.svg", 
    colorScheme: "sport-color--gray",
    color: "#6b7280" // gray
  },
  Trivia: { 
    svgUrl: "/new_trivia_logo.svg", 
    colorScheme: "sport-color--indigo",
    color: "#6366F1" // gray
  }
};

export const events = [
  {
    id: 176,
    description: "TATA IPL 2025 Player Auction, Day 2",
    start_at: "2024-11-25T10:00:00+00:00",
    sport: { id: 1, label: "Cricket" },
    league: { id: 1, label: "Pro Cricket" },
    home_team: { id: 1, label: "TBD" },
    away_team: { id: 1, label: "TBD" },
    screen_group: { id: 1, label: "Main" },
    showings: [
      {
        id: 258,
        duration: 420,
        channels: [{ display: { label: "WILLOW" }, number_display: "9540" }],
      },
    ],
    priority: 1, // Added priority field
  },
  {
    id: 188,
    description: "Abu Dhabi T10 Cricket: Team Abu Dhabi vs. New York Strikers",
    start_at: "2024-11-25T11:30:00+00:00",
    sport: { id: 1, label: "Cricket" },
    league: { id: 1, label: "Pro Cricket" },
    home_team: { id: 1, label: "TBD" },
    away_team: { id: 1, label: "TBD" },
    screen_group: { id: 2, label: "Bar" },
    showings: [
      {
        id: 279,
        duration: 90,
        channels: [{ display: { label: "WILLOW" }, number_display: "9540" }],
      },
    ],
    priority: 2, // Added priority field
  },
  {
    id: 189,
    description:
      "Abu Dhabi T10 Cricket: Deccan Gladiators vs. Northern Warriors",
    start_at: "2024-11-25T12:00:00+00:00",
    sport: { id: 1, label: "Basketball" },
    league: { id: 1, label: "Pro Cricket" },
    home_team: { id: 1, label: "TBD" },
    away_team: { id: 1, label: "TBD" },
    screen_group: { id: 2, label: "Bar" },
    showings: [
      {
        id: 280,
        duration: 90,
        channels: [{ display: { label: "WILLOW" }, number_display: "9540" }],
      },
    ],
    priority: 3, // Added priority field
  },
];
